import script from "./AnnouncementModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementModal.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementModal.vue?vue&type=style&index=0&id=a86f58dc&lang=scss"

export default script